export const iconFontAwesomeShoppingCamera = (
	<i className="fa-solid fa-camera"></i>
);
